import api from "apis/appraiserCountyFiles";
import { HTTP_DELETE, HTTP_POST, HTTP_GET, WebApiRequest } from "tools/webservice";

export const addFile = (appraiserId, file, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: api.add(appraiserId),
  file,
  successCallback,
  mountedRef,
});

export const deleteFile = (fileId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: api.delete(fileId),
  successCallback,
  mountedRef,
});

export const getFileList = (appraiserId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getList(appraiserId),
  successCallback,
  mountedRef,
});

export const downloadFile = (fileId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getFileDownload(fileId),
  successCallback,
  mountedRef,
});

export const viewFile = (fileId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: api.getFileView(fileId),
  successCallback,
  mountedRef,
});
